const RankRoutes = [
    {
        path: 'getTmcScore',
        name: 'getTmcScore',
        component: () => import('@/views/Rank/getTmcScore'), // 获取TMC得分
        meta: {
            title: 'synchronizeTMCResults'
        }
    },{
        path:'tmcSyncState',
        name:'tmcSyncState',
        component:()=>import('@/views/Rank/tmcSyncState'),
        meta:{
            title:'tmcSyncInfo'
        }
    },
    {
        path: 'tmcCapabilityAssessmentModification',
        name: 'tmcCapabilityAssessmentModification',
        component: () => import('@/views/Rank/tmcCapabilityAssessmentModification'), // 获取TMC得分
        meta: {
            title: 'tmcCapabilityAssessmentModification'
        }
    },
    {
        path: 'tmcScoreEdit',
        name: 'tmcScoreEdit',
        component: () => import('@/views/Rank/tmcScoreEdit'), // TMC详情
        meta: {
            title: 'tmcScoreEdit'
        }
    },
    {
        path: 'tmcScoreDetail',
        name: 'tmcScoreDetail',
        component: () => import('@/views/Rank/tmcScoreDetail'), // TMC详情
        meta: {
            title: 'tmcScoreDetail'
        }
    },
    {
        path: 'rankList',
        name: 'rankList',
        component: () => import('@/views/Rank/rankList'), // 排名
        meta: {
            keepAlive: true,
            title: 'forcedDistribution'
        }
    },
    {
        path: 'rankDetail',
        name: 'rankDetail',
        component: () => import('@/views/Rank/rankDetail'), // 排名(强制分布)
        meta: {
            title: 'forcedDistributionDetail'
        }
    },
    {
        path: 'summaryScore',
        name: 'summaryScore',
        component: () => import('@/views/Rank/summaryScore/summaryScore'), // 汇总得分(综合考评结果计算)
        meta: {
            title: 'comprehensiveCalculation'
        }
    },
    {
        path: 'stiSummaryScore',
        name: 'stiSummaryScore',
        component: () => import('@/views/Rank/stiSummaryScore/stiSummaryScore'), // 汇总得分(STI)
        meta: {
            title: 'stiCalculation'
        }
    },
    {
        path: 'summaryCalUnlock',
        name: 'summaryCalUnlock',
        component: () => import('@/views/Rank/summaryCalUnlock'), // 汇总计算解锁（IT）
        meta: {
            title: 'summaryCalUnlock'
        }
    },
    {
        path: 'rateListDetail2',
        name: 'rateListDetail2',
        component: () => import('@/views/Rank/rateListDetail2'), // 评等详情(直接下属强制分布)
        meta: {
            title: 'directReportsDistributionDetail'
        }
    },
    {
        path: 'rateList',
        name: 'rateList',
        component: () => import('@/views/Rank/rateList'), // 评等(直接下属强制分布)
        meta: {
            keepAlive: true,
            title: 'directReportsDistribution'
        }
    },
    {
        path: 'deptRank5',
        name: 'deptRank5',
        component: () => import('@/views/Rank/deptRank5'), // 五级部门排名
        meta: {
            title: 'deptDistribution'
        }
    },
    {
        path: 'deptRank5Detail',
        name: 'deptRank5Detail',
        component: () => import('@/views/Rank/deptRank5Detail'), // 五级部门排名-详情
        meta: {
            title: 'deptDistributionDetail'
        }
    },
    {
        path: 'companyChargeRank',
        name: 'companyChargeRank',
        component: () => import('@/views/Rank/companyChargeRank'), // 公司负责人排名
        meta: {
            title: 'companyDistribution',
            keepAlive: true,
        }
    },
    {
        path: 'companyChargeRankDetail',
        name: 'companyChargeRankDetail',
        component: () => import('@/views/Rank/companyChargeRankDetail'), // 公司负责人排名-详情
        meta: {
            title: 'companyDistribution-Detail'
        }
    },


]
export default RankRoutes